import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import './App.css';

// Landing pages
import Home_1 from './landing/Home';

// Dashboard shell + views
import Home from './dashboard/Home';
import DashboardHome from './dashboard/Home';
import DashboardCategories from './dashboard/Categories';
import DashboardFavorites from './dashboard/Favorites';
import DashboardSettings from './dashboard/Settings';
import DashboardCategorySingle from './dashboard/SingleCategory';


import { ModalProvider } from './helpers/ModalContext';
import { AlertProvider } from './helpers/AlertContext'; // make sure the path is correct

import GameModal from './components/GameModal';
import AuthGuard from './helpers/AuthGuard';
import GermanSettings from './dashboard/GermanSettings';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ModalProvider>


    <AlertProvider>

      <BrowserRouter>
        <AuthGuard>
          <Routes>
            <Route path="/" element={<Home_1 />} />

            <Route path="/dashboard/home" element={<DashboardHome />} />
            <Route path="/dashboard/categories" element={<DashboardCategories />} />
            <Route path="/dashboard/favorites" element={<DashboardFavorites />} />
            <Route path="/dashboard/settings" element={<DashboardSettings />} />
            <Route path="/dashboard/aboverwaltung" element={<GermanSettings />} />
            <Route path="/dashboard/single" element={<DashboardCategorySingle />} />

          </Routes>
          <GameModal /> {/* Place once here */}
        </AuthGuard>

      </BrowserRouter>
    </AlertProvider>


  </ModalProvider >

);
